module.exports = __webpack_public_path__ + "img/ws.dfd0f32a.png";